import { apiClient } from '@shoots/auth'
import type { Event } from '../types/index'

export class EventService {
  /**
   * Fetch a single event by ID
   */
  async getEvent(eventId: string): Promise<Event> {
    try {
      const response = await apiClient.get<Event>(
        `/functions/v1/gathering?id=${eventId}`
      )
      return response
    } catch (error) {
      console.error('Failed to fetch event:', error)
      throw error
    }
  }
}

// Export a singleton instance
export const eventService = new EventService()
